import "../../css/inner-page/sectionSmsAssets.scss";
import CTA from "../CTA";

export default function Section(props) {
  return (
    <section id="sms-assets">
      <div className="wrapper">
        <div>
          <span className="type">{props.asset.type}</span>
          <h2 data-aos="fade">{props.asset.title}</h2>
          <p data-aos="fade-up">{props.asset.content}</p>
          <CTA
            href={props.asset.cta.url}
            title={props.asset.cta.title}
            segmentLocation="SMS resources"
            segmentBtnName={props.asset.cta.title}
          />
          <img src={props.asset.image_group["1x"]} alt={props.asset.image_group.alt} />
        </div>
        <div>
          <span className="type">{props.asset_2_asset.type}</span>
          <h2 data-aos="fade">{props.asset_2_asset.title}</h2>
          <p data-aos="fade-up">{props.asset_2_asset.content}</p>
          <CTA
            href={props.asset_2_asset.cta.url}
            title={props.asset_2_asset.cta.title}
            segmentLocation="SMS resources"
          />
          <img
            src={props.asset_2_asset.image_group["1x"]}
            alt={props.asset_2_asset.image_group.alt}
            segmentBtnName={props.asset_2_asset.cta.title}
          />
        </div>
      </div>
    </section>
  );
}
